import { Heart } from "lucide-react";
import { useWishlist, useWishToggle } from "@/contexts/WishlistContext";

/** Heart on product cards / product page. Safe inside a <Link> card. */
export default function HeartButton({ p, className = "", size = "h-4 w-4" }) {
  const w = useWishlist();
  const toggle = useWishToggle();
  const on = w?.has(p);
  return (
    <button
      type="button"
      aria-pressed={!!on}
      aria-label={on ? "Remove from wishlist" : "Save to wishlist"}
      data-testid={`heart-${p.id}`}
      onClick={(e) => { e.preventDefault(); e.stopPropagation(); toggle(p); }}
      className={`rounded-full bg-white/90 hover:bg-white shadow-sm flex items-center justify-center h-8 w-8 transition-transform hover:scale-105 ${className}`}
    >
      <Heart className={`${size} ${on ? "text-terracotta fill-terracotta" : "text-stone-500"}`} />
    </button>
  );
}
